<template>
  <div class="color-transform">
    <div class="color-transform__content">
      <div v-if="type === 'rgba'" class="rgba-bar w-4/5">
        <div v-for="(item, index) in rgba" :key="index" class="item">{{ item }}</div>
      </div>
      <div v-if="type === 'hsla'" class="hsla-bar w-4/5">
        <div v-for="(item, index) in hsla" :key="index" class="item">{{ item }}</div>
      </div>
      <div v-if="type === 'hex'" class="hsla-bar w-4/5">
        <div class="item pl-2 text-left">{{ hex }}</div>
      </div>
      <dropdown class="w-1/5">
        <div class="drop-btn">
          <i class="el-icon-arrow-down" />
        </div>
        <dropdown-menu slot="dropdown" class="color-transform__popper">
          <dropdown-item v-for="item in typeOptions" :key="item.value" @click.native="handleChangeType(item)">
            <i class="el-icon-check font-bold" :class="{ 'visible': item.value === type }" />
            <span>{{ item.label }}</span>
          </dropdown-item>
        </dropdown-menu>
      </dropdown>
    </div>
    <div v-if="type === 'rgba'" class="color-transform__tip">
      <div class="w-1/5 item">R</div>
      <div class="w-1/5 item">G</div>
      <div class="w-1/5 item">B</div>
      <div class="w-1/5 item">A</div>
      <div class="w-1/5 item"> </div>
    </div>
    <div v-if="type === 'hsla'" class="color-transform__tip">
      <div class="w-1/5 item">H</div>
      <div class="w-1/5 item">S</div>
      <div class="w-1/5 item">L</div>
      <div class="w-1/5 item">A</div>
      <div class="w-1/5 item"> </div>
    </div>
    <div v-if="type === 'hex'" class="color-transform__tip">
      <div class="item pl-2">HEX</div>
    </div>
  </div>
</template>

<script>
import { colord } from 'colord'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
export default {
  components: {
    Dropdown,
    DropdownMenu,
    DropdownItem
  },
  props: {
    value: [String, Array]
  },
  data() {
    return {
      rgba: [],
      hsla: [],
      hex: '',
      type: 'rgba',
      typeOptions: [
        {
          label: 'RGBA',
          value: 'rgba'
        },
        {
          label: 'HSLA',
          value: 'hsla'
        },
        {
          label: 'HEX',
          value: 'hex'
        }
      ]
    }
  },
  watch: {
    value() {
      this.getValue()
    }
  },
  methods: {
    getValue() {
      const color = colord(this.value)
      const rgba = color.toRgb()
      this.rgba = [rgba.r, rgba.g, rgba.b, rgba.a]
      const hslaString = color.toHslString()
      const hsla = hslaString.substring(4, hslaString.length - 1).split(',')
      this.hsla = [hsla[0].includes('(') ? hsla[0].substring(1, hsla[0].length) : hsla[0], hsla[1], hsla[2], (hsla[3] || 1)]
      this.hex = color.toHex()
    },
    handleChangeType(item) {
      this.type = item.value
    }
  }
}
</script>

<style lang="less">
.color-transform {
  padding-bottom: 12px;
  
  &__popper {
    background-color: var(--popper-bg);
    border: 1px solid var(--border-color-base);
    box-shadow: var(--shadow-lg);
    border-radius: 4px;
    padding: 4px 0;
    
    .popper__arrow {
      display: none;
    }
    .el-icon-check {
      visibility: hidden;
      margin-right: 8px;
    }
    .el-icon-check.visible {
      visibility: visible;
    }
    .el-dropdown-menu__item {
      color: var(--text-color);
      font-size: 12px;
      line-height: 28px;
      padding: 0 16px;
      
      &:hover {
        background-color: var(--bg-color-hover);
        color: var(--text-color);
      }
      &:focus {
         background-color: var(--bg-color-hover);
      }
    }
  }
  
  &__content {
    width: 100%;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
  }
  
  &__tip {
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
    
    .item {
      text-align: center;
      font-size: 12px;
      color: var(--text-secondary);
      transform: scale(0.9);
    }
  }
  
  .rgba-bar,.hsla-bar, .hex-bar {
    display: flex;
    height: 28px;
    background-color: var(--bg-color-base);
    border-radius: 4px 0 0 4px;
    border: 1px solid var(--border-color-base);
    border-right: none;
    
    .item {
      flex: 1;
      height: 100%;
      text-align: center;
      line-height: 26px;
      color: var(--text-color);
      font-size: 12px;
    }
  }
  
  .drop-btn {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-color-base);
    color: var(--text-color);
    border-radius: 0 4px 4px 0;
    border: 1px solid var(--border-color-base);
    cursor: pointer;
    transition: background-color 0.3s;
    
    &:hover {
        background-color: var(--bg-color-hover);
    }
    
    .el-icon-arrow-down {
        color: var(--text-secondary);
        font-weight: bold;
    }
  }
}
</style>
